module.exports = __webpack_public_path__ + "img/icon_wy08.59eccb7c.png";